<!-- Button -->

@if (!core.currentUser$$()) {
  <button mat-icon-button (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'" />
  </button>
}
@if (core.currentUser$$()) {
  <button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
      @if (showAvatar && core.currentUser$$()) {
        <app-avatar
          [imageFileKey]="core.currentUser$$() | avatarFileKey" />
      }
      @if (!showAvatar) {
        <mat-icon
        [svgIcon]="'heroicons_outline:user-circle'" />
      }
      <span class="absolute bottom-0 right-0 h-2 w-2 rounded-full"></span>
    </span>
  </button>
  <mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>현재 유저</span>
        <span class="text-md mt-1.5 font-medium">
          {{ core.currentUser$$().emailAddress }}
        </span>
      </span>
    </button>
    <mat-divider class="my-2" />
    <button mat-menu-item (click)="signOut()">
      <mat-icon
      [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'" />
      <span>로그아웃</span>
    </button>
  </mat-menu>
}
